import api from '../utils/api';

function withEmail(path, email) {
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}email=${encodeURIComponent(email)}`;
}

export async function fetchEvidencePacks(email, params = {}) {
  const qs = new URLSearchParams({ email, ...params }).toString();
  const res = await api.get(`/client/reports/packs?${qs}`);
  return res.data;
}

export async function fetchEvidencePackDetail(historyId, email) {
  const res = await api.get(
    `/client/reports/packs/${encodeURIComponent(historyId)}?email=${encodeURIComponent(email)}`
  );
  return res.data;
}

export async function fetchExceptions(email, params = {}) {
  const qs = new URLSearchParams({ email, ...params }).toString();
  const res = await api.get(`/client/reports/exceptions?${qs}`);
  return res.data;
}

export async function patchException(id, email, body) {
  const res = await api.patch(
    `/client/reports/exceptions/${encodeURIComponent(id)}?email=${encodeURIComponent(email)}`,
    { ...body, email }
  );
  return res.data;
}

export async function fetchFollowUps(email, params = {}) {
  const qs = new URLSearchParams({ email, ...params }).toString();
  const res = await api.get(`/client/reports/follow-ups?${qs}`);
  return res.data;
}

export async function patchFollowUp(id, email, body) {
  const res = await api.patch(
    `/client/reports/follow-ups/${encodeURIComponent(id)}?email=${encodeURIComponent(email)}`,
    { ...body, email }
  );
  return res.data;
}

export async function fetchReports(email, params = {}) {
  const qs = new URLSearchParams({ email, ...params }).toString();
  const res = await api.get(`/client/reports?${qs}`);
  return res.data;
}

export async function fetchComplianceSettings(email) {
  const res = await api.get(withEmail('/client/compliance/settings', email));
  return res.data;
}

export async function updateComplianceSettings(email, body) {
  const res = await api.put(withEmail('/client/compliance/settings', email), {
    ...body,
    email,
  });
  return res.data;
}

export async function upsertManualClean(historyId, email, body) {
  const res = await api.put(
    `/client/reports/packs/${encodeURIComponent(historyId)}/manual-clean?email=${encodeURIComponent(
      email
    )}`,
    { ...body, email }
  );
  return res.data;
}

export async function createVerification(historyId, email, body) {
  const res = await api.post(
    `/client/reports/packs/${encodeURIComponent(historyId)}/verifications?email=${encodeURIComponent(
      email
    )}`,
    { ...body, email }
  );
  return res.data;
}

export async function patchRoomRiskTier(roomId, email, riskTier) {
  const res = await api.patch(
    `/client/rooms/${encodeURIComponent(roomId)}/risk-tier?email=${encodeURIComponent(email)}`,
    { riskTier, email }
  );
  return res.data;
}

export { withEmail };
